import axios from "axios";
import { getStoredToken } from "../auth/AuthProvider";

const api = axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api/v1",

  // baseURL: process.env.REACT_APP_API_BASE_URL || "https://food-ordering-backend-sazb.onrender.com/api/v1",
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://biteflow-app-atg0hubwetg9akg3.southeastasia-01.azurewebsites.net/api/v1/",


});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const extractErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    return (
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Request failed"
    );
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Unexpected error";
};

export default api;
